import projection from '../generated/pw220af1.json'; import { AcceptanceManifest } from '../types';
export const pw220af1AcceptanceManifest = projection as AcceptanceManifest;
